import {
  StudentsPerformanceFilters,
  getStudentsPerformances,
} from '@/data/services/studentsPerformance';

export const studentsPerformanceQueries = {
  all: ['studentsPerformance'] as const,

  list: (filters: StudentsPerformanceFilters = {}) => ({
    queryKey: [...studentsPerformanceQueries.all, 'list', { filters }] as const,
    queryFn: () => getStudentsPerformances(filters),
  }),
};
